import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  AddAdviceProductsToCartStartData,
  AddAkaAdviceProductsToCartStartData,
  AddProductToCartEntity,
  AddProductToCartError,
  AddProductsToCartData,
} from "./interfaces";

const initialState: AddProductToCartEntity = {
  current: null,
  isLoading: false,
  error: null,
};

const addProductToCartSlice = createSlice({
  name: "addProductToCart",
  initialState,
  reducers: {
    resetAddProductToCart: (state) => {
      state.current = null;
      state.isLoading = false;
      state.error = null;
    },

    addProductsToCartStart: (
      state,
      _action: PayloadAction<AddProductsToCartData>,
    ) => {
      state.isLoading = true;
    },

    addProductToCartSucceeded: (state) => {
      state.isLoading = false;
      state.error = null;
    },

    addAdviceProductsToCartStart: (
      state,
      _action: PayloadAction<AddAdviceProductsToCartStartData>,
    ) => {
      state.isLoading = true;
      state.error = null;
    },

    addAkaAdviceProductsToCartStart: (
      state,
      _action: PayloadAction<AddAkaAdviceProductsToCartStartData>,
    ) => {
      state.isLoading = true;
      state.error = null;
    },

    operationFailed: (state, action: PayloadAction<AddProductToCartError>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  addProductsToCartStart,
  addAdviceProductsToCartStart,
  addAkaAdviceProductsToCartStart,
  addProductToCartSucceeded,
  operationFailed,
  resetAddProductToCart,
} = addProductToCartSlice.actions;
export const addProductToCart = addProductToCartSlice.reducer;
